/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Control_UpdatedInputs */

const en_control_updated = /** @type {(inputs: Control_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Last updated`)
};

const zh_control_updated = /** @type {(inputs: Control_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最后核实`)
};

/**
* | output |
* | --- |
* | "Last updated" |
*
* @param {Control_UpdatedInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const control_updated = /** @type {((inputs?: Control_UpdatedInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Control_UpdatedInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_control_updated(inputs)
	return zh_control_updated(inputs)
});
export { control_updated as "control.updated" }